import { onMounted, onUnmounted, onActivated, onDeactivated } from 'vue'

// Lets whichever calendar is showing (Dashboard's embedded calendar, or the
// /admin/calendar/* routes) register how to switch its Day/Month mode, so the
// global "1"/"2" shortcuts (AppRoot.vue) can drive it — same pattern as
// useActiveTeacherDropdown. Module-level singleton; the most recently
// mounted/activated host wins.
let host = null

export function useActiveCalendarMode() {
  return {
    isAvailable: () => !!host && host.isAvailable(),
    setMode: mode => { if (host?.isAvailable()) host.setMode(mode) },
  }
}

// setMode(mode: 'day' | 'month'). Hooks both mount and keep-alive
// activation, since CalendarView is kept alive by AppRoot and Dashboard isn't.
export function registerCalendarModeHost(setMode, isAvailable = () => true) {
  const self = { setMode, isAvailable }
  const on = () => { host = self }
  const off = () => { if (host === self) host = null }
  onMounted(on); onActivated(on)
  onUnmounted(off); onDeactivated(off)
}
